import axios from '../../../node_modules/axios'
import {shareUrl} from "../../common/api/api";
import wx from 'weixin-js-sdk'

// 微信分享
function getWeixinAuth() {
  let paramsUrl = {
    "url": window.location.href
  };
  axios.get( '//m.ql1d.com/get_page_config.do', {params: paramsUrl})
    .then(res => {
      const data = res.data.data;
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo']
      });
      let title = document.getElementsByTagName('title')[0].textContent;
      let link = window.location.href;//.split('&')[0];
      // 注册微信分享信息
      wx.ready(function () {
        let config = {
          title: title + '-齐鲁壹点', // 分享标题
          desc: '来自齐鲁晚报·齐鲁壹点新闻客户端', // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://img.qiluyidian.net/shareimg20191216.jpg', // 分享图标
          // imgUrl: 'https://miniapp.qiluyidian.mobi/22e301830f8ac7bb2e6f3db121076f4.png', // 分享图标 黑白
          success() {
          },
          cancel() {
          },
          fail(res) {
          }
        }
        wx.onMenuShareTimeline(config)
        wx.onMenuShareAppMessage(config)
        wx.onMenuShareQQ(config)
        wx.onMenuShareQZone(config)
        wx.onMenuShareWeibo(config)
      })
    }, err => {
      //toast('获取微信认证失败', 2000);
    })
    .catch((error) => {

    })
  // shareUrl(paramsUrl).then(res => {
  //   if (res.data.rc == 0) {
  //     const {data} = res.data.data;
  //     wx.config({
  //       debug: false,
  //       appId: data.appId,
  //       timestamp: data.timestamp,
  //       nonceStr: data.nonceStr,
  //       signature: data.signature,
  //       jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo']
  //     });
  //     let title = document.getElementsByTagName('title')[0].textContent;
  //     let link = window.location.href;//.split('&')[0];
  //     // 注册微信分享信息
  //     wx.ready(function () {
  //       let config = {
  //         title: title, // 分享标题
  //         desc: title, // 分享描述
  //         link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //         imgUrl: 'https://wscdn.ql1d.com/web/lib/img/share-logo.png', // 分享图标
  //         success() {
  //         },
  //         cancel() {
  //         },
  //         fail(res) {
  //         }
  //       }
  //       wx.onMenuShareTimeline(config)
  //       wx.onMenuShareAppMessage(config)
  //       wx.onMenuShareQQ(config)
  //       wx.onMenuShareQZone(config)
  //       wx.onMenuShareWeibo(config)
  //     })
  //   } else {
  //     toast('获取微信认证失败', 2000);
  //   }
  // }).catch((err) => {
  // })
}
function toast(msg, duration) {
  duration = isNaN(duration) ? 3000 : duration;
  var m = document.createElement('div');
  m.innerHTML = msg;
  m.style.cssText = "max-width:60%;min-width: 150px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 14px;";
  document.body.appendChild(m);
  setTimeout(function () {
    var d = 0.5;
    m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
    m.style.opacity = '0';
    setTimeout(function () {
      document.body.removeChild(m)
    }, d * 1000);
  }, duration);
};
export {getWeixinAuth}



// WEBPACK FOOTER //
// ./src/common/js/weixinshare.js